import slice from "lodash/slice";
import { defaultI18nProvider, feathersProvider } from '@/legacy';
import authProvider from './auth';
import { config } from '@/config/env';
import { requireActiveTenancy } from '@/features/tenancy';

import enMessages from "@/i18n/locales/en.json";
import zhMessages from "@/i18n/locales/zh.json";

export const dataProvider = feathersProvider({
  host: config.BACKEND_URL,
  getUrlFromAuth: true,
  trailingResourceSlash: config.ENFORCE_URL_RESOURCE_SLASH === "true" ? true : false,
  customHeaders: (headers) => {
    headers["X-TENANCY"] = requireActiveTenancy();
    return headers;
  },
});

export const i18nProvider = defaultI18nProvider(
  "en",
  {
    en: enMessages,
    "zh-Hans": zhMessages,
  },
  {
    allowMissing: true,
    onMissingKey: (t) => {
      if (typeof t === "object") {
        return t.toString();
      }

      // Remove the translation prefix
      const split = t.split(".");
      if (["options", "stage", "control", "screen"].includes(split[0])) return slice(split, 1).join(".");

      return t;
    },
  },
);

// re-export
export { authProvider };
